<!-- Header -->
<app-header *ngIf="isPanelEnabled()"></app-header>
<app-side-nav *ngIf="isPanelEnabled()"></app-side-nav>
<!-- Body content -->
<router-outlet></router-outlet>
<!-- Footer -->

<ng-container *ngIf="loading$ | async">
  <div class="overlay"></div>
  <div style="color: #0452D7;  z-index: 1000000;" class="la-square-loader la-2x">
    <div></div>
  </div>
</ng-container>
<div #targetContainer></div>
